module.exports = __webpack_public_path__ + "img/img_utility.ec7a5450.png";